import { createContext } from 'react';

export type DataCacheContextVal = {
  createDataCache: (
    endpoint: string,
    updateDelay: number,
    objectsListener: (e: MessageEvent) => void,
    useFakeData?: boolean
  ) => void;
  sse: EventSource | null;
};

export const DataCacheContext = createContext<DataCacheContextVal>({
  createDataCache: (
    endpoint: string,
    updateDelay: number,
    objectsListener: (e: MessageEvent) => void,
    useFakeData?: boolean
  ) => {
    throw new Error('createDataCache() not implemented');
  },
  sse: null,
});
